import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { IconButton, Button, Drawer as MUIDrawer } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import UserIcon from './user-icon/user-icon';
import Config from '../../../run-config';

import FilterContainer from './filter-container';

class Drawer extends Component {
  renderHeader() {
    const {
      userName, logout, changePassword, toggleFiltersOpen,
    } = this.props;
    return (
      <div className="filter-header">
        <UserIcon
          onLogout={logout}
          changePassword={changePassword}
          loggedIn
        />
        <div className="user-name">{userName}</div>
        <IconButton onClick={() => toggleFiltersOpen()} style={{ paddingRight: 10 }} classes={{ root: 'desktop-drawer-button' }}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
    );
  }

  renderExecuteButton() {
    const { loadAllReportData } = this.props;
    return(
      <div className="filter-executeButton">
      <Button 
        style={{width: "100%", fontSize: 25}}
        onClick={() => loadAllReportData()}
        variant="contained"
        color="primary">
          Abfragen
        </Button>
        </div>
    )
  }

  renderLogo() {
    return(
      <a className="brand-ref" href="https://apro.at/" rel="noopener noreferrer" target="_blank">
      <div className="filter-logo">
        <img alt="logo" src={Config.loginLogo} />
      </div>
    </a>
    )
  }

    renderFooter() {
      const { selectedReport } = this.props;
      return (
        <div>
          {selectedReport && selectedReport.isCashboxReport ? (
            this.renderExecuteButton()
          ) : (
            this.renderLogo()
          )}
        </div>
      );
    }
    

  render() {
    const {
      filtersOpen,
    } = this.props;

    return (
      <MUIDrawer
        className="filter-container doNotPrint"
        elevation={20}
        variant="persistent"
        anchor="left"
        open={filtersOpen}
        classes={{
          paper: 'filter-paper',
        }}
      >
        {this.renderHeader()}
        <FilterContainer />
        {this.renderFooter()}
      </MUIDrawer>
    );
  }
}

Drawer.propTypes = {
  filtersOpen: PropTypes.bool,
  userName: PropTypes.string,
  logout: PropTypes.func,
  changePassword: PropTypes.func,
  toggleFiltersOpen: PropTypes.func,
};

Drawer.defaultProps = {
  filtersOpen: true,
  userName: '',
  logout: () => {},
  changePassword: () => {},
  toggleFiltersOpen: () => {},
};

export default Drawer;
